import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import vueSwiper from 'vue-awesome-swiper'
import Message from 'vue-m-message'

import 'css/reset.css'
import 'css/border.css'
import 'swiper/css/swiper.css'
import 'css/common.styl'
import 'vue-m-message/dist/index.css'

// 引入i18n
Vue.use(VueI18n)
// 轮播
Vue.use(vueSwiper)

Vue.use(Message)

const i18n = new VueI18n({
  locale: 'en-US',
  messages: {
    'zh-CN': require('./common/lang/cn'), // 中文语言包
    'en-US': require('./common/lang/en')  // 英文语言包
  }
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js